module.exports = __webpack_public_path__ + "static/media/marc.aba54d65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/faces/marc.jpg
// module id = 252
// module chunks = 0